import { sliderProps, Slider } from './chunk-JQ3KENEW.js';
import { SliderStoreFactory } from './chunk-53B74NMI.js';
import { functionThrottle } from './chunk-JELAJF2G.js';
import { round } from './chunk-CVLY5S52.js';
import { setAttributeIfEmpty } from './chunk-Z6A4GYXE.js';
import { effect } from 'maverick.js';
import { defineElement, defineProp } from 'maverick.js/element';

var VolumeSlider = class extends Slider {
  constructor() {
    super(...arguments);
    this.pc = true;
    this.Qd = functionThrottle(this.Kb.bind(this), 25);
  }
  onAttach(el) {
    setAttributeIfEmpty(el, "aria-label", "Media volume");
    super.onAttach(el);
    effect(this.hc.bind(this));
  }
  hc() {
    const { muted, volume } = this.a.$store;
    const newValue = muted() ? 0 : volume() * 100;
    this.$store.value.set(newValue);
    this.dispatch("value-change", { detail: newValue });
  }
  Kb(event) {
    if (!event.trigger)
      return;
    const mediaVolume = round(event.detail / 100, 3);
    this.a.remote.changeVolume(mediaVolume, event);
  }
  lc(event) {
    this.Qd(event);
  }
  mc(event) {
    this.Qd(event);
  }
  sc() {
    return 0;
  }
  tc() {
    return 100;
  }
};
VolumeSlider.el = defineElement({
  tagName: "media-volume-slider",
  props: {
    ...sliderProps,
    min: defineProp({ value: 0, attribute: false }),
    max: defineProp({ value: 100, attribute: false }),
    value: defineProp({ value: 100, attribute: false })
  },
  store: SliderStoreFactory
});

export { VolumeSlider };
